import {LitigationRequest, LitigationStructRequest, LitigationInteractor} from "../../Coordinator/Litigation/LitigationInteractor";

export class LitigationViewModel {
    private interactor: LitigationInteractor;

    constructor() {
        this.interactor = new LitigationInteractor();
    }

    public fetchSave(obj: any): PromiseLike<any> {
        var request = new LitigationRequest(
            obj["sgeplitigio"] ? parseInt(obj["sgeplitigio"]) : 0,
            obj["nome"] ? obj["nome"] : "",
        )
        
        return new Promise((res, rej) => {  
            this.interactor.fetchSave(request).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }

    public fetchDataOne(obj: any): PromiseLike<any> {
        var request = new LitigationStructRequest(
            obj["sgeplitigio"] ? parseInt(obj["sgeplitigio"]) : 0
        )
        
        return new Promise((res, rej) => {
            this.interactor.fetchDataOne(request).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }
}
